import React from 'react'
import { useSelector } from 'react-redux'
import { Text, Link } from 'chemistry'

const CategoryBanner = () => {
  const banner = useSelector(state => state.data.banner)
  if (!banner) return <div id='banner-widget-container' style={{ width: '100%' }} /> // for GTM
  const { title, subTitle, link, picture, mobPic, imageAlt, imageTitle } = banner

  if (!picture) return null

  return (
    <div id='banner-widget-container' className='mxd-lister-widgets'>
      <picture>
        <source srcSet={picture} media='(min-width: 768px)' />
        <source srcSet={mobPic || picture} media='(max-width: 767px)' style={{ objectFit: 'cover' }} />
        <img className='col-12' alt={imageAlt} title={imageTitle} src={mobPic} />
      </picture>
      {(title || subTitle) && (
        <Link href={link || '#'} className='flex justify-center items-center flex-column'>
          <Text fontSize='4xl' fontFamily='bold' color='offYellow.500'>
            {title}
          </Text>
          <Text fontSize='xl' fontFamily='bold' color='offYellow.500'>
            {subTitle}
          </Text>
        </Link>
      )}
    </div>
  )
}

export default React.memo(CategoryBanner)
